import Immutable from 'immutable';
import React from 'react';
import { mergeWithSession } from '../card/session-card';

export default (Component, property = 'viewer') => (props) => (
  <Component
    {...Immutable.Map(props)
      .map((val, key) => {
        return key === property ? mergeWithSession(Immutable.fromJS(val)) : val;
      })
      .toJS()}
  />
);



// WEBPACK FOOTER //
// ./src/components/dashboard/session.js